import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { formatDate } from 'ngx-bootstrap/chronos';

@Injectable()
export class FechaService {

    constructor() {}

    cambioFormato(fecha: string): string {
        const valores = fecha.split('-');
        return valores[2] + '-' + valores[1] + '-' + valores[0];
    }

    cambioFormatoHora(fecha: string): string {
        const valoresSeparados = fecha.split('T');
        const valores = valoresSeparados[0].split('-');
        const valores_tiempo = valoresSeparados[1].split(':');
        return valores[2] + '-' + valores[1] + '-' + valores[0] + ' ' + valores_tiempo[0] + ':' + valores_tiempo[1]  + ':00';
    }

    obtenerFormatoDateActual() {
        const date = new Date();
        return (date.getFullYear().toString() + '-'
       + ('0' + (date.getMonth() + 1)).slice(-2) + '-'
       + ('0' + (date.getDate())).slice(-2))
       + 'T' + date.toTimeString().slice(0, 5);
    }

    obtenerFormatoDateMilis(milis) {
        var date = new Date((milis+(3600000*5)));
        date.setDate(date.getDate())
        var year = date.getFullYear();
        year = year < 2000 ? (year + 2000) : year;
        var month = (date.getMonth() + 1) + "";
        month = month.length > 1 ? month : '0'+month;
        var day = (date.getDate()) + "";
        day = day.length > 1 ? day : '0'+day;
        return (year + '-' + month.slice(-2) + '-'  + day.slice(-2));
    }

    obtenerFormatoDateMilisMs(milis) {
        milis = milis + 100        
        var date = new Date(parseInt(milis));
        date.setDate(date.getDate() +1)
        var year = date.getFullYear();
        year = year < 2000 ? (year + 2000) : year;
        var month = (date.getMonth() + 1) + "";
        month = month.length > 1 ? month : '0'+month;
        var day = (date.getDate()) + "";
        day = day.length > 1 ? day : '0'+day;
        return (year + '-' + month.slice(-2) + '-'  + day.slice(-2));
    }

    obtenerFormatoDateAnterior() {
    const today = new Date();
    return (today.getFullYear().toString() + '-'
       + ('0' + (today.getMonth() + 1)).slice(-2) + '-'
       + ('0' + (today.getDate())).slice(-2))
       + 'T00:00';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/fecha/fecha.service.ts